import React from 'react';
import GenericFeatures from '../GenericFeatures';
import styles from './styles.scss';

const FEATURES = [
  {
    name: 'Online textbook',
    icon: 'fad fa-books',
    description:
      'Our comprehensive online textbook. Easy to read, mobile-friendly, and with detailed breakdowns of sample questions. Written by an industry-leading expert with many years of experience.',
  },
  {
    name: 'Memory-tracked quiz questions',
    icon: 'fad fa-user-chart',
    description:
      "Prepare in less time with thousands of quizzes. As you study, Achievable's advanced learning engine updates a personalized model of your memory to efficiently cover all material while focusing on your trickiest topics.",
  },
  {
    name: 'Unlimited, randomized practice exams (coming soon)', // TODO(finra-series-6)
    icon: 'fad fa-file-certificate',
    description:
      "Simulate exam day with full-length, realistic practice exams. Specifically written with similar difficulty, wording, and weighting as the actual exam. Question text and variables are randomized to be sure you're learning the concepts instead of simply recalling answers.",
  },
  {
    name: 'A full year of access',
    icon: 'fad fa-calendar-check',
    description:
      "You'll have plenty of time to prepare. And if life gets in the way, just let us know. We're people too and we understand.",
  },
  {
    name: 'Amazing customer support',
    icon: 'fad fa-users',
    description:
      "You've probably already noticed that our site is filled with various ways to talk with us. We want to hear from you!",
  },
];

const DefaultFeatures = () => (
  <>
    <GenericFeatures features={FEATURES} />
    <div className={styles.layout}>
      <div className={styles.title}>EARLY ACCESS</div>
      <div>
        <p>
          <b>This course is in early access and may not yet include all features.</b>
        </p>
        <p>
          At Achievable, we launch our courses chapter by chapter as we build them. This
          allows us to develop our content faster and get feedback quicker. We conduct
          initial QA during this phase, but please know that you are buying a
          work-in-progress and not a fully finished piece of art.
        </p>
        <p>
          While courses are in early access, we offer a substantial discount to encourage
          you to purchase it early. This discount is reduced as we continue to release
          more pieces of the course, so the earlier you buy, the cheaper the price.
        </p>
        <p>
          When you buy an early access course, you immediately get access to everything
          we&apos;ve built up to that point, and updates will be automatically added to
          your account.
        </p>
        <p>
          Once the course is officially launched, we will then start the timer for the
          year of access.
        </p>
        <ul>
          <li>There may be typos in the content</li>
          <li>Images may be missing</li>
          <li>Review quizzes may be missing</li>
          <li>Practice exams will be added at the very end</li>
        </ul>
      </div>
    </div>
  </>
);

export default DefaultFeatures;
